import { setBooleanFeatureFlagResolver } from '@atlaskit/platform-feature-flags';
import { type BridgeData } from '@databases/database-state/state/bridge-data';
import { StatsigClient } from '@databases/feature-flags/client/statsig';
import {
  featureFlagClientManager,
  getFeatureFlagsInUse,
} from '@databases/feature-flags/manager';
import { perf } from '@databases/logs/performance';

import { setContext } from '@canvas/sentry-react';

export const initializeFeatureFlags = async ({
  cloudId,
  userId,
}: Pick<BridgeData, 'cloudId' | 'userId'>) => {
  perf.timeLog('app-initialization', 'feature-flags-start');

  setBooleanFeatureFlagResolver((flagKey) => {
    return [
      'platform.linking-platform.datasource.show-jlol-basic-filters',
      'platform.linking-platform.datasource.show-clol-basic-filters',
    ].includes(flagKey);
  });

  featureFlagClientManager.add(
    new StatsigClient(
      (process.env.BUILD_MODE as 'stg-east' | 'prod-east') ?? 'stg-east',
      cloudId,
      userId
    )
  );
  await featureFlagClientManager.initialize();

  const featureFlagsInUse = getFeatureFlagsInUse();

  if (featureFlagsInUse.length > 0) {
    setContext('Feature Flags', {
      'In Use': featureFlagsInUse,
    });
  }
};
